import {type FC, memo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as CRUProgramDurationProps} from './Duration';

import CRUProgramDuration from './Duration';

type Props = Partial<ModalProps> & CRUProgramDurationProps;

const CRUProgramDurationModal: FC<Props> = ({
  children,
  duration,
  onSet,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal {...modalProps} title={t('shared:CRUProgramDuration.title')}>
      <CRUProgramDuration duration={duration} onSet={onSet} />
      {children}
    </Modal>
  );
};

export default memo(CRUProgramDurationModal);
